import createVueComponent from '../createVueComponent';

const SignalZero = createVueComponent('SignalZeroIcon', [
  ['path', { d: 'M2 20h.01' }],
  ['path', { d: 'M7 20v-4' }],
]);

export default SignalZero;
